import { useState, useRef, useEffect } from 'react';

import TreeView from '../shared/TreeView';
import { addToSelectedList } from '../shared/UtilFunctions';
import {
  buildUnitCodesFromMasterData,
  useScopeClearAll
} from '../shared/scopeUtils';

import { Facet } from '../shared/Facet';

export default function ScopeFilter(props) {
  const { masterInputTreeJson, commonProps, selectedUnits } = props;
  const { setParentFilter } = commonProps;
  const parentSetSelectedUnits = props.setSelectedUnits;
  const [selectedScope, setSelectedScope] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [clearAll, setClearAll] = useScopeClearAll(selectedUnits);
  const lastSelectedUnitsKeyRef = useRef(null);

  function selectedList() {
    let list = [];

    masterData.forEach((item) => {
      if (item.checked) {
        addToSelectedList(list, item.name, 'Region', true);
      } else {
        item.children &&
          item.children.forEach((child) => {
            if (child.checked) {
              addToSelectedList(list, child.name, 'Country', true);
            } else {
              child.children &&
                child.children.forEach((gchild) => {
                  if (gchild.checked) {
                    addToSelectedList(list, gchild.name, 'Unit', true);
                  }
                });
            }
          });
      }
    });
    // Sort list
    list.sort((a, b) => a.parent.localeCompare(b.parent));
    setSelectedScope(list);
    setParentFilter && setParentFilter({ scopeFilter: list });

    const unitCodes = buildUnitCodesFromMasterData(masterData);
    const unitsKey =
      Array.isArray(unitCodes) && unitCodes.length > 0
        ? unitCodes.join('|')
        : '';

    if (unitsKey !== lastSelectedUnitsKeyRef.current) {
      lastSelectedUnitsKeyRef.current = unitsKey;
      parentSetSelectedUnits(unitCodes);
    }
  }

  useEffect(() => {
    if (masterData) selectedList();
  }, [masterData]);
  return (
    <Facet defaultActiveKey="scope_filter">
      <Facet.Item
        id="scope_filter"
        title="Scope"
        openByDefault={true}
        selectedItems={[]}
        selectedCount={selectedScope.length}
        clearSelection={() => {
          setSelectedScope([]);
          lastSelectedUnitsKeyRef.current = null;
          parentSetSelectedUnits(null);
          setClearAll(true);
        }}
      >
        <TreeView
          key={
            Array.isArray(selectedUnits)
              ? selectedUnits.join(',')
              : (selectedUnits ?? '')
          }
          commonProps={commonProps}
          masterInputTreeJson={masterInputTreeJson}
          showInOneColumn={true}
          showFilter={true}
          filterPlaceHolder="Filter by Region, Country or Unit"
          donotShowClearButton={true}
          selectAll={false}
          addVScrollBar={true}
          setParentMasterData={setMasterData}
          setParentClearAllFlag={setClearAll}
          clearAllFlag={clearAll}
          selectedUnits={selectedUnits}
          invalidError={null}
        />
      </Facet.Item>
    </Facet>
  );
}
